/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-patient-attribute.reducer';

export const HospitalPatientAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalPatientAttributeEntity = useAppSelector(state => state.hospitalPatientAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalPatientAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.detail.title">HospitalPatientAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientAttributeEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalPatientAttributeEntity.hospital ? hospitalPatientAttributeEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.patientCategory">Patient Category</Translate>
          </dt>
          <dd>{hospitalPatientAttributeEntity.patientCategory ? hospitalPatientAttributeEntity.patientCategory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPatientAttribute.patient">Patient</Translate>
          </dt>
          <dd>{hospitalPatientAttributeEntity.patient ? hospitalPatientAttributeEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-patient-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-patient-attribute/${hospitalPatientAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalPatientAttributeDetail;
